// extracted by mini-css-extract-plugin
export default {"input":"TableSearchInput_input__G5zW4","section":"TableSearchInput_section__ufBZy"};